import React, { Component } from 'react';
import { loginService } from '../../services/login.service';
import Loader from '../../_helpers/Loader';
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import { helperText } from '../../_helpers/helpertext';
import { isEmailValid, isStringEmpty } from '../../_helpers/string_helper';
import RegisterMemberModel from '../../Models/RegisterMemberModel';
import { adminservice } from '../../services/admin.service';
import { historypush } from '../../_helpers/utilities';
import eye from "../../Images/eye.png";

class AdminMemberRegister extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isLoading:false,
            memberId:0,
            memberNumber:0,
            serialNumber:0,
            firstName:'',
            surname:'',
            branch:'',
            email:'',
            memberClass:'',
            houseNumber:'',
            area:'',
            village:'',
            pincode:'',
            password:'',
            classList:[],
            slectedGrade:'1',
            errorMessage: {},
            showNewSucessMessage:false,
            showEditSucessMessage:false,
            showFailureMessage:false,
            captcha:'',
            showPassword: false,
            showPasswordField : true,
            showOthertab:false,
            classificationLevelOneList:[],
            classificationLevelTwoList:[],
            otherText:'',
            selectedClassificationLevelOne:"99",
            selectedClassificationLevelTwo:"",
            showOtherOption:true,
        };
        this.memberInput=React.createRef();
        this.serialInput=React.createRef();
        this.firstNameInput=React.createRef();
        this.surnameInput=React.createRef();
        this.branchInput=React.createRef();
        this.emailInput=React.createRef();
        this.houseInput=React.createRef();
        this.areaInput=React.createRef();
        this.villageInput=React.createRef();
        this.pincodeInput=React.createRef();
        this.passwordInput=React.createRef();
        this.captchaInput=React.createRef();
    }

    componentDidMount=()=>{
      loadCaptchaEnginge(6); 
      this.getClass();
      this.getClassification();
      let memberIdToEdit=localStorage.getItem("EditMemberId");
      if(memberIdToEdit != undefined){
        this.setState({
          memberId:memberIdToEdit,
          showPasswordField:false,
        })
        this.getmemberDetail(memberIdToEdit);
      }
    }

    getmemberDetail=async(memberId)=>{
      this.setState({isLoading:true});
      var response=await adminservice.GetMemberDetail(memberId);
      if(response.status === 200){
        this.setState({
          memberNumber:response.data.memberNumber,
            serialNumber:response.data.serialNumber,
            firstName:response.data.firstName,
            surname:response.data.surname,
            branch:response.data.branch,
            email:response.data.email,
            slectedGrade:response.data.classId,
            houseNumber:response.data.houseNo,
            area:response.data.area,
            village:response.data.village,
            pincode:response.data.pincode,
            password:response.data.password,
            selectedClassificationLevelOne:response.data.classificationLevel1,
            selectedClassificationLevelTwo:response.data.classificationLevel2,
            otherText:response.data.otherClassificationLevel,
            showOthertab:(response.data.otherClassificationLevel == null ? false : true)
        })
      }
      this.setState({isLoading:false});
    }
    doSubmit = () => {
      // <! --   let's assume there is an HTML input text box with id 'user_captcha_input' to get user input -->   
           if(this.state.memberId == 0){
           let user_captcha_value = document.getElementById('user_captcha_input').value;
           var error = this.state.errorMessage;
           if (validateCaptcha(user_captcha_value) === true) {
              error["emptyCaptcha"] = '';
              this.setState({ errorMessage: error });
              return true;
           }
           else {
               //alert('Captcha Does Not Match');
               if(user_captcha_value === ""){
                  error["emptyCaptcha"] = helperText.registerPageText.emptyCaptcha;
                  this.setState({ errorMessage: error });
                  this.captchaInput.current.focus();
                  return false;
               }else{
                  error["emptyCaptcha"] = helperText.registerPageText.wrongCaptcha;
                  this.setState({ errorMessage: error });
                  this.captchaInput.current.focus();
                  return false;
               }
           }
          }else{
            return true;
          }
       };

    /* <summary>
    date: 04-07-2022
    Name: VD
    description: This is used to get the list of all the class to map in class dropdown
    <summary>*/ 
    getClass=async()=>{
      try{
        
      this.setState({isLoading:true})

      var response = await loginService.GetClassList();
      if(response.status === 200){
        let list = response.data;
        this.setState({classList:list.slice(0,list.length-1)});
      }else if(response.status===401){
        localStorage.clear();
        historypush('/login');
      }
      this.setState({isLoading:false})
      }catch(e){
        return "";
      }
    }

    OnEventChange(e) {
        const { name, value } = e.target;
        this.setState({
            [name]: value,

      }
    )}

    onChangeNumber = (e) => {
      var value = 0;
      if (e.target.value < 0) {
        value = 0;
      } else {
        value = e.target.value;
      }
      const { name } = e.target;
      this.setState({
        [name]: value,
      });
  
      // this.setState({
      //   errorMessage: {},
      // });
  };

    /* <summary>
    date: 04-07-2022
    Name: VD
    description: Validation part ,The validation has been from bottom to top to show the top error first ...
    <summary>*/ 
    validate=()=>{
      const{
        memberNumber,
        serialNumber,
        firstName,
        surname,
        branch,
        email,
        houseNumber,
        area,
        village,
        pincode,
        password,
        captcha,
        showPasswordField,
        memberId
      }=this.state;
      var isValid = true;
      var isCaptchaValid = true;
      if(memberId == 0){
        if(memberNumber === 0 ||
          firstName === "" ||
          surname === "" ||
          branch === "" ||
          email === "" ||
          houseNumber === "" ||
          pincode === "" ||
          (showPasswordField && password === "") 
        ){
          isValid = false;
        }else{
          isValid = true;
        }
      }else{
        if(memberNumber === 0 ||
          memberNumber === null ||  
          surname === ""||
          surname === null || 
          email === ""||
          email === null)
        {
          isValid = false;
        }else{
          isValid = true;
        }
      }

      var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

      this.setState({ errorMessage: {} });
      var error = this.state.errorMessage;
      // if(isStringEmpty(password)){
      //   error["emptyPassword"] = helperText.memberRegistration.emptyPassword;
      //   this.setState({ errorMessage: error });
      //   this.passwordInput.current.focus();
      // }else{
      //   error["emptyPassword"] = '';
      //   this.setState({ errorMessage: error });
      // }

      if(memberId == 0){
        let user_captcha_value = document.getElementById('user_captcha_input').value;
        var error = this.state.errorMessage;
        if (validateCaptcha(user_captcha_value) === true) {
           error["emptyCaptcha"] = '';
           this.setState({ errorMessage: error });
           isCaptchaValid = true;
        }
        else {
            //alert('Captcha Does Not Match');
            if(user_captcha_value === ""){
               error["emptyCaptcha"] = helperText.registerPageText.emptyCaptcha;
               this.setState({ errorMessage: error });
               this.captchaInput.current.focus();
               isCaptchaValid = false;
            }else{
               error["emptyCaptcha"] = helperText.registerPageText.wrongCaptcha;
               this.setState({ errorMessage: error });
               this.captchaInput.current.focus();
               isCaptchaValid = false;
            }
        }
      }else{
        isCaptchaValid = true;
      }

      if(showPasswordField == true){
        if(isStringEmpty(password)){
          error["emptyPassword"] = helperText.resetPageText.emptyPassword;
          this.setState({ errorMessage: error });
          this.passwordInput.current.focus();
        }

        if(format.test(password)){
          if (password.length > 7) {
            error["emptyPassword"] = '';
            this.setState({ errorMessage: error });
          } else {
            error["emptyPassword"] = helperText.resetPageText.passwordLength;
            this.setState({ errorMessage: error });
            this.passwordInput.current.focus();
            
          }
        }else{
          error["emptyPassword"] = helperText.resetPageText.specialCharacterMissing;
          this.setState({ errorMessage: error });
          this.passwordInput.current.focus();
        }
      }
      
      if(memberId == 0){
        if(isStringEmpty(pincode)){
          error["emptyPincode"] = helperText.memberRegistration.emptyPincode;
          this.setState({ errorMessage: error });
          this.pincodeInput.current.focus();
        }else{
          error["emptyPincode"] = '';
          this.setState({ errorMessage: error });
        }
        
        // if(isStringEmpty(village)){
        //   error["emptyVillage"] = helperText.memberRegistration.emptyVillage;
        //   this.setState({ errorMessage: error });
        //   this.villageInput.current.focus();
        // }else{
        //   error["emptyVillage"] = '';
        //   this.setState({ errorMessage: error });
        // }
        
        // if(isStringEmpty(area)){
        //   error["emptyArea"] = helperText.memberRegistration.emptyArea;
        //   this.setState({ errorMessage: error });
        //   this.areaInput.current.focus();
        // }else{
        //   error["emptyArea"] = '';
        //   this.setState({ errorMessage: error });
        // }
        
        if(isStringEmpty(houseNumber)){
          error["emptyhouseNumber"] = helperText.memberRegistration.emptyhouseNumber;
          this.setState({ errorMessage: error });
          this.houseInput.current.focus();
        }else{
          error["emptyhouseNumber"] = '';
          this.setState({ errorMessage: error });
        }
      }

      if(isStringEmpty(email)){
        error["emptyEmail"] = helperText.registerPageText.emptyEmail;
        this.setState({ errorMessage: error });
        this.emailInput.current.focus();
      }else if (!isEmailValid(email)){
        error["emptyEmail"] = helperText.memberRegistration.wrongEmail;
        this.setState({ errorMessage: error });
        this.emailInput.current.focus();
      }else{
          error["emptyEmail"] = '';
          this.setState({ errorMessage: error });
      }

      if(memberId == 0){
        if(isStringEmpty(branch)){
          error["emptyBranch"] = helperText.memberRegistration.emptyBranch;
          this.setState({ errorMessage: error });
          this.branchInput.current.focus();
        }else{
          error["emptyBranch"] = '';
          this.setState({ errorMessage: error });
        }
      }

      if(isStringEmpty(surname)){
        error["emptySurname"] = helperText.memberRegistration.emptySurname;
        this.setState({ errorMessage: error });
        this.surnameInput.current.focus();
      }else{
        error["emptySurname"] = '';
        this.setState({ errorMessage: error });
      }

      if(memberId == 0){
        if(isStringEmpty(firstName)){
          error["emptyFirstName"] = helperText.memberRegistration.emptyFirstName;
          this.setState({ errorMessage: error });
          this.firstNameInput.current.focus();
        }else{
          error["emptyFirstName"] = '';
          this.setState({ errorMessage: error });
        }
      }

      if(memberId == 0){
        if(serialNumber === ""){
        //   error["emptySerialNumber"] = helperText.memberRegistration.emptySerialNumber;
        //   this.setState({ errorMessage: error });
        //   this.serialInput.current.focus();
          this.setState({serialNumber:0})
        }
        //else if(serialNumber === "0"){
        //   error["emptySerialNumber"] = helperText.memberRegistration.zeroSerialNumber;
        //   this.setState({ errorMessage: error });
        //   this.serialInput.current.focus();
        // }else{
        //   error["emptySerialNumber"] = '';
        //   this.setState({ errorMessage: error });
        // }
      }
      if(memberNumber === ''){
        error["emptymemberNumber"] = helperText.memberRegistration.emptymemberNumber;
        this.setState({ errorMessage: error });
        this.memberInput.current.focus();
      }else if(memberNumber === 0){
        error["emptymemberNumber"] = helperText.memberRegistration.emptymemberNumber;
        this.setState({ errorMessage: error });
        this.memberInput.current.focus();
      }else{
        error["emptymemberNumber"] = '';
        this.setState({ errorMessage: error });
      }

      if(isCaptchaValid && isValid){
        this.addEditMemberRegistration();
      }
    }

    /* <summary>
    date: 04-07-2022
    Name: VD
    description: This is used to save or update the member details in the member table
    <summary>*/ 
    addEditMemberRegistration=async()=>{
      try{
        this.setState({isLoading:true});
        const{
          memberId,
          memberNumber,
          serialNumber,
          firstName,
          surname,
          branch,
          email,
          slectedGrade,
          houseNumber,
          area,
          village,
          pincode,
          password,
          selectedClassificationLevelOne,
          selectedClassificationLevelTwo,
          otherText,
        }=this.state;
        var register = new RegisterMemberModel();
        register.memberId = memberId;
        register.memberNumber = memberNumber;
        register.serialNumber = serialNumber === ""?0:serialNumber;
        register.firstName = firstName;
        register.surname = surname;
        register.branch = branch;
        register.email = email;
        register.classId = slectedGrade;
        register.houseNo = houseNumber;
        register.area = area;
        register.village = village;
        register.pincode = pincode;
        register.password = password;
        register.classificationLevel1=Number(selectedClassificationLevelOne);
        register.classificationLevel2=Number(selectedClassificationLevelTwo);
        register.otherClassificationLevel=otherText;

        var response=await adminservice.AddEditMemberRegistration(register);
        if(response.status === 200){
          if(response.data === true){
            if(memberId == 0 ){
              this.setState({showNewSucessMessage:true});
            }else{
              this.setState({showEditSucessMessage:true});
            }
            
            historypush('/details');
          }else{
            this.setState({showFailureMessage:true})
          }
        }

        this.setState({isLoading:false});
      }catch(e){
        return "";
      }
    }

    clearAll(){
      this.setState({
        // memberNumber:0,
        // serialNumber:0,
        // firstName:'',
        // surname:'',
        // branch:'',
        // email:'',
        // memberClass:'',
        // houseNumber:'',
        // area:'',
        // village:'',
        // pincode:'',
        // password:'',
        // slectedGrade:'1',
        errorMessage: {},
        showNewSucessMessage:false,
        showEditSucessMessage:false,
        showFailureMessage:false,
        // captcha:'',
      })
    }

    toggleEye = () => {
      const currentState = this.state.showPassword;
      this.setState({ showPassword: !currentState });
    };

    goBack=()=>{
          historypush('/details');
  }

  getClassification=async()=>{
    try{
    this.setState({isLoading:true})
    var response = await loginService.GetClassificationList();
    if(response.status === 200){
      let list = response.data;
      this.setState({
        classificationLevelOneList:list
      },async()=>{
        this.filterClassificationLevelTwoForDropDown();
      })
    }else if(response.status===401){
      localStorage.clear();
      historypush('/login');
    }
    this.setState({isLoading:false})
    }catch(e){
      return "";
    }
  }

  /* <summary>
  date: 22-09-2022
  Name: VD
  description: This is used to bind the level two data based on what the level one is selected
  <summary>*/ 
  onClassificationLevelOneChange=(e)=>{
    var value = e.target.value;

    if(value == "1" ||value == "3" || value == "4" ){
      this.setState({showOtherOption:true});
    }else{
      this.setState({showOtherOption:false});
    }

    this.setState({
      selectedClassificationLevelOne:value,
      showOthertab:false
    },async()=>{
      this.filterClassificationLevelTwoForDropDown()
    });
  }

  /* <summary>
  date: 22-09-2022
  Name: VD
  description: This is used to filter the Level 2 based on the things selected in level 1
  <summary>*/ 
  filterClassificationLevelTwoForDropDown=()=>{
    const{selectedClassificationLevelOne,classificationLevelOneList}=this.state;
    var filterLevelTwo=classificationLevelOneList.filter((item)=>
      item.classificationLevelOneId == selectedClassificationLevelOne
    );
    this.setState({
      classificationLevelTwoList:filterLevelTwo[0].classificationLevel2Models,
      //selectedClassificationLevelTwo:filterLevelTwo[0].classificationLevel2Models[0].classificationLevelTwoId
    })
    let memberIdToEdit=localStorage.getItem("EditMemberId");
    if(memberIdToEdit == undefined){
      this.setState({
        selectedClassificationLevelTwo:filterLevelTwo[0].classificationLevel2Models[0].classificationLevelTwoId
      })
    }
  }

  /* <summary>
  date: 22-09-2022
  Name: VD
  description: This is used to bind the level two data and to show and hide the other text field
  <summary>*/ 
  onClassificationLevelTwoChange=(e)=>{
    var value = e.target.value;
    this.setState({
      selectedClassificationLevelTwo:value
    });
    if(value == "99"){
      this.setState({showOthertab:true});
    }else{
      this.setState({showOthertab:false,otherText:""});
    }
  }


    render() {
        const{
            isLoading,
            memberNumber,
            serialNumber,
            firstName,
            surname,
            branch,
            email,
            memberClass,
            houseNumber,
            area,
            village,
            pincode,
            password,
            slectedGrade,
            classList,
            showNewSucessMessage,
            showEditSucessMessage,
            showFailureMessage,
            captcha,
            showPassword,
            memberId,
            showPasswordField,
            classificationLevelOneList,
            selectedClassificationLevelOne,
            classificationLevelTwoList,
            selectedClassificationLevelTwo,
            showOtherOption,
            showOthertab,
            otherText,
        }=this.state;
        return (
        <div className="register-main-page">
            {isLoading && <Loader />}
          <div className="container">
              <div className="Register-form register">
                <h4>Enter Member Information</h4>
                <h5 className="requiredfield">Please fill all the necessary fields (<i>*</i><span>indicates required field)</span></h5>
                <div className="personalinfo">
                  <div className="personaldata"><h5>Personal Information</h5></div>
                  <div className="table-data">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-md-6"><label><h6>Member Number:{memberId == 0?<span>*</span>:""}</h6>{/*</label*/}</label></div>
                          <div className="col-md-5 col-11">
                            <input type="number" 
                                className="form-control" 
                                id="number" 
                                value={memberNumber == 0 ? '' : memberNumber}
                                name="memberNumber"
                                onChange={this.onChangeNumber}
                                style={{}} 
                                required 
                                ref={this.memberInput}
                            /> 
                            <div className="error-message col-md-5 col-11" style={{ display: this.state.errorMessage.emptymemberNumber ? "contents" : "none",color: "red" }}>
                              <div style={{marginTop:'-5px'}}>{this.state.errorMessage.emptymemberNumber}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-md-6"><label><h6>Serial Number:</h6>{/*</label*/}</label></div>
                          <div className="col-11 col-md-5">
                            <input type="number" 
                                className="form-control" 
                                id="number" 
                                value={serialNumber == 0 ? '' : serialNumber}
                                name="serialNumber"
                                onChange={this.onChangeNumber}
                                style={{}} 
                                required 
                                ref={this.serialInput}
                            />
                            <div className="error-message col-11 col-md-5" style={{ display: this.state.errorMessage.emptySerialNumber ? "contents" : "none",color: "red" }}>
                            <div style={{marginTop:'-5px'}}>{this.state.errorMessage.emptySerialNumber}</div>
                          </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-md-6"><label><h6>First Name:{memberId == 0?<span>*</span>:""}</h6></label></div>
                          <div className="col-11 col-md-5">
                            <input type="name" 
                                className="form-control" 
                                id="name"
                                value={firstName}
                                name="firstName"
                                onChange={this.OnEventChange.bind(this)} 
                                required 
                                ref={this.firstNameInput}
                            />
                            <div className="error-message col-11 col-md-5" style={{ display: this.state.errorMessage.emptyFirstName ? "contents" : "none",color: "red" }}>
                              <div style={{marginTop:'-5px'}}>{this.state.errorMessage.emptyFirstName}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-md-6"><label><h6>Surname:<span>*</span></h6></label></div>
                          <div className="col-11 col-md-5">
                            <input type="name" 
                            className="form-control" 
                            id="name" 
                            value={surname}
                            name="surname"
                            onChange={this.OnEventChange.bind(this)} 
                            required
                            ref={this.surnameInput} />
                            <div className="error-message col-11 col-md-5" style={{ display: this.state.errorMessage.emptySurname ? "contents" : "none",color: "red" }}>
                              <div style={{marginTop:'-5px'}}>{this.state.errorMessage.emptySurname}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-md-6"><label><h6>Branch:{memberId == 0?<span>*</span>:""}</h6></label></div>
                          <div className="col-11 col-md-5">
                            <input type="name" 
                            className="form-control" 
                            id="name" 
                            value={branch}
                            name="branch"
                            onChange={this.OnEventChange.bind(this)} 
                            required
                            ref={this.branchInput} />
                            <div className="error-message col-11 col-md-5" style={{ display: this.state.errorMessage.emptyBranch ? "contents" : "none",color: "red" }}>
                              <div style={{marginTop:'-5px'}}>{this.state.errorMessage.emptyBranch}</div>
                            </div>  
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-md-6"><label><h6>Email Address:<span>*</span></h6></label></div>
                          <div className="col-11 col-md-5">
                            <input type="email" 
                            className="form-control" 
                            id="email" 
                            value={email}
                            name="email"
                            onChange={this.OnEventChange.bind(this)} 
                            required 
                            ref={this.emailInput}/>
                            <div className="error-message col-11 col-md-5" style={{ display: this.state.errorMessage.emptyEmail ? "contents" : "none",color: "red" }}>
                              <div style={{marginTop:'-5px'}}>{this.state.errorMessage.emptyEmail}</div>
                            </div>  
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-md-6"><label><h6>Grade:<span>*</span></h6></label></div>
                          <div className="col-11 col-md-5">
                            {/* <input type="name" 
                            className="form-control" 
                            id="name"
                            value={memberClass}
                            name="memberClass"
                            onChange={this.OnEventChange.bind(this)} 
                            required /> */}
                            <select 
                            className="form-select form-select-lg mb-3" 
                            aria-label=".form-select-lg example"
                            value={slectedGrade}
                            name="slectedGrade"
                            onChange={this.OnEventChange.bind(this)}
                            style={{fontSize:'16px',height:'38px'}}
                            >
                              {classList.map((item)=>{
                                return(
                                  <option value={item.classID}>{item.className}</option>
                                )
                              })}
                            </select>
                            </div>
                        </div>
                      </div>
                      <div className="col-md-6" />
                        <div className="col-md-6">
                          <div className="row">
                            <div className="col-md-6">
                              <label>
                                <h6>Level 1 Classification:</h6>
                              </label>
                            </div>
                            <div className="col-11 col-md-5">
                            <select 
                              className="form-select form-select-lg mb-3" 
                              aria-label=".form-select-lg example"
                              value={selectedClassificationLevelOne}
                              name="selectedClassificationLevelOne"
                              onChange={(e)=>this.onClassificationLevelOneChange(e)}
                              style={{fontSize:'16px',height:'39px', paddingTop:'0px', paddingBottom:'0px'}}
                              >
                                <option value="99" selected disabled></option>
                                {classificationLevelOneList.map((item)=>{
                                  return(
                                    <option value={item.classificationLevelOneId}>{item.classificationLevelOneName}</option>
                                  )
                                })}
                            </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6" />
                        <div className="col-md-6">
                          <div className="row">
                            <div className="col-md-6">
                              <label>
                                <h6>Level 2 Classification:</h6>
                              </label>
                            </div>
                            <div className="col-11 col-md-5">
                              <select 
                                className="form-select form-select-lg mb-3" 
                                aria-label=".form-select-lg example"
                                value={selectedClassificationLevelTwo}
                                name="selectedClassificationLevelTwo"
                                onChange={(e)=>this.onClassificationLevelTwoChange(e)}
                                style={{fontSize:'16px',height:'39px', paddingTop:'0px', paddingBottom:'0px'}}
                                >
                                  {classificationLevelTwoList.map((item)=>{
                                    return(
                                      <option value={item.classificationLevelTwoId}>{item.classificationLevelTwoName}</option>
                                    )
                                  })}
                                  {showOtherOption && classificationLevelTwoList.length>0 && (
                                    <option value='99'>Others</option>
                                  )}
                              </select>
                            </div>
                          </div>
                        </div>
                        {showOthertab && (
                          <div className="col-md-6">
                            <div className="row">
                              <div className="col-md-6">
                              <label>
                                <h6>Others</h6>
                                </label>
                              </div>
                              <div className="col-11 col-md-5">
                                <input type="email" 
                                className="form-control" 
                                id="otherText" 
                                value={otherText}
                                name="otherText"
                                onChange={this.OnEventChange.bind(this)} />
                              </div>
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
                <div className="personalinfo">
                  <div className="personaldata"><h5>Contact Details</h5></div>
                  <div className="table-data">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col-md-3"><label><h6>House No. /Building:{memberId == 0?<span>*</span>:""}</h6></label></div>
                          <div className="col-11 col-md-9">
                            <textarea type="name" 
                            className="form-control form-contol-mob" 
                            id="name"
                            value={houseNumber}
                            name="houseNumber"
                            onChange={this.OnEventChange.bind(this)}  
                            rows={2} style={{width: '94%'}} required 
                            ref={this.houseInput}/>
                            <div className="error-message col-11 col-md-5" style={{ display: this.state.errorMessage.emptyhouseNumber ? "contents" : "none",color: "red" }}>
                              <div style={{marginTop:'-5px'}}>{this.state.errorMessage.emptyhouseNumber}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col-md-3"><label><h6>Area/ Locality:</h6></label></div>
                          <div className="col-11 col-md-9">
                            <textarea type="name" 
                            className="form-control form-contol-mob" 
                            id="name" 
                            value={area}
                            name="area"
                            onChange={this.OnEventChange.bind(this)}  
                            rows={2} style={{width: '94%'}} required
                            ref={this.areaInput}/>
                            <div className="error-message col-11 col-md-5" style={{ display: this.state.errorMessage.emptyArea ? "contents" : "none",color: "red" }}>
                              <div style={{marginTop:'-5px'}}>{this.state.errorMessage.emptyArea}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="row">
                          <div className="col-md-3"><label><h6>Village/ Town/ City:</h6></label></div>
                          <div className="col-11 col-md-9">
                            <textarea type="name" 
                            className="form-control form-contol-mob" 
                            id="name"
                            value={village}
                            name="village"
                            onChange={this.OnEventChange.bind(this)}  
                            rows={2} style={{width: '94%'}} required
                            ref={this.villageInput}/>
                            <div className="error-message col-11 col-md-5" style={{ display: this.state.errorMessage.emptyVillage ? "contents" : "none",color: "red" }}>
                              <div style={{marginTop:'-5px'}}>{this.state.errorMessage.emptyVillage}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="row">
                          <div className="col-md-6"><label><h6>Pincode:{memberId == 0?<span>*</span>:""}</h6></label></div>
                          <div className="col-11 col-md-5">
                            <input type="text" 
                            className="form-control" 
                            id="number"
                            value={pincode}
                            name="pincode"
                            onChange={this.onChangeNumber} 
                            required style={{height: '38px'}} 
                            ref={this.pincodeInput}/>
                            <div className="error-message col-11 col-md-5" style={{ display: this.state.errorMessage.emptyPincode ? "contents" : "none",color: "red" }}>
                              <div style={{marginTop:'-5px'}}>{this.state.errorMessage.emptyPincode}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {showPasswordField?
                  <div className="personalinfo">
                    <div className="personaldata"><h5>Member Password</h5></div>
                    <div className="table-data">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="row">
                            <div className="col-md-6"><label><h6>Member Password:<span>*</span></h6></label></div>
                            <div className="col-11 col-md-5">
                              <input 
                                type={showPassword ? "text" : "password"}
                                className="form-control" 
                                id="number"
                                value={password}
                                name="password"
                                onChange={this.OnEventChange.bind(this)}  
                                required style={{height: '38px'}} 
                                ref={this.passwordInput}
                              />
                              <img
                                style={{ marginLeft: "85%", marginTop: "-87px",cursor :'pointer' }}
                                src={eye}
                                onClick={this.toggleEye}
                              />
                              <div className="error-message col-11 col-md-5" style={{ display: this.state.errorMessage.emptyPassword ? "contents" : "none",color: "red" }}>
                                <div style={{marginTop:'-29px'}}>{this.state.errorMessage.emptyPassword}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6" />
                        {memberId == 0 ?
                        <div className="col-md-6">
                          <div className="row">
                            <div className="col-md-6"><label><h6>Enter Code:<span>*</span></h6></label></div>
                            <div className="col-11 col-md-5">
                              <input type="name" 
                                className="form-control"  
                                id="user_captcha_input" 
                                value={captcha}
                                name="captcha"
                                onChange={this.OnEventChange.bind(this)}  
                                required 
                                ref={this.captchaInput}
                              />
                              <div className="error-message col-11 col-md-5" style={{ display: this.state.errorMessage.emptyCaptcha ? "contents" : "none",color: "red" }}>
                                <div style={{marginTop:'-5px'}}>{this.state.errorMessage.emptyCaptcha}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                        :""}
                      {memberId == 0 ?
                        <div className="col-md-6">
                          {/* <div className="row captchabutton">
                            <div className="col-6 col-md-6"><img src="images/CAPTCHA-2.jpg" alt="captcha" /></div>
                            <div className="col-5 col-md-5"><button type="button" className="btn">Refresh</button></div>
                          </div> */}
                          <LoadCanvasTemplate />
                        </div>
                        :""}
                      </div>
                    </div>
                  </div>
                :""}
                <div className="registerbutton" id="my_form">
                  <input className="Login-btn" type="submit" onClick={()=>this.validate()} id="nextStep" style={{padding: '6px 35px'}} value="SUBMIT" />
                  <input className="cancel-btn" type="reset" onClick={()=>this.clearAll()} style={{padding: '6px 22px'}} value="CANCEL" />
                  
                </div>
                {showNewSucessMessage && (
                  <div id="thank_you" className="alert alert-success" style={{ fontSize: '24px'}}>
                      {/* <a onclick="closeForm()" className="close" style={{float: 'right', color: 'black', textDecoration: 'none', fontSize: '24px'}} data-dismiss="alert" aria-label="close">×</a> */}
                      
                      Success! You have successfully registered.
                      <button type="button" className="btn-close" data-bs-dismiss="alert" style={{float: 'right',fontSize: '17px',padding: '10px'}} />
                  </div>
                )}
                {showEditSucessMessage && (
                  <div id="thank_you" className="alert alert-success" style={{ fontSize: '24px'}}>
                      {/* <a onclick="closeForm()" className="close" style={{float: 'right', color: 'black', textDecoration: 'none', fontSize: '24px'}} data-dismiss="alert" aria-label="close">×</a> */}
                      
                      Member details has been successfully updated.
                      <button type="button" className="btn-close" data-bs-dismiss="alert" style={{float: 'right',fontSize: '17px',padding: '10px'}} />
                  </div>
                )}
                {showFailureMessage && (
                  <div id="failure" className="alert" style={{fontSize: '24px', backgroundColor: '#e78c8c', borderColor: '#e47779', color: '#730f0f'}}>
                    {/* <a onclick="closeForm()" className="close" style={{float: 'right', color: 'black', textDecoration: 'none', fontSize: '24px'}} data-dismiss="alert" aria-label="close">
                      ×
                    </a> */}
                    <strong>Error!</strong> Oops, something went wrong. Please try again later.
                    <button type="button" className="btn-close" data-bs-dismiss="alert" style={{float: 'right',fontSize: '17px',padding: '10px'}}  />
                  </div>
                )}
              </div>
              <button type="button" className="question-button question-mob-button btn btn-white" onClick={()=>this.goBack()}>Back</button>
          </div>
        </div>  
        );
    }
}

export default AdminMemberRegister;